// extracted by mini-css-extract-plugin
export var active = "_97-a";
export var activeIndicator = "_97-8";
export var animate = "_97-9";
export var disabled = "_97-b";
export var fullWidth = "_97-2";
export var lg = "_97-7";
export var md = "_97-6";
export var redoButtonTabGroup = "_97-0";
export var sm = "_97-5";
export var tabButton = "_97-3";
export var tabButtonsContainer = "_97-1";
export var xs = "_97-4";